<template>
  <section class="mb-5 pb-5">
    <h1 class="mb-3">Demo...</h1>

    <section class="mb-3 border rounded p-3 bg-light">
      <h4>Test: JSON Viewer</h4>
      <hr />
      <JsonViewer
        :value="demoJson"
        :expand-depth="5"
        :copyable="{copyText: 'copy', copiedText: 'copied'}"
        boxed
        sort
      />
    </section>

    <!-- TESTING REAL EXAMPLE -->
    <section class="mb-3 border rounded p-3 bg-light">
      <h4>Test: model methods</h4>
      <hr />

      <!-- <label>{{ methodName }}</label> -->
      <div class="mt-3" @keypress.enter="loadApplication">
        <el-input placeholder="Application ID" v-model="application_id" class="w-50">
          <el-select
            v-model="method"
            slot="prepend"
            placeholder="Select"
            :style="{ minWidth: 110 }"
          >
            <el-option label="Create" value="create"></el-option>
            <el-option label="Select" value="select"></el-option>
            <el-option label="Update" value="update"></el-option>
            <el-option label="Delete" value="delete"></el-option>
          </el-select>
          <!-- <el-button slot="append" icon="el-icon-search"></el-button> -->
          <el-button
            slot="append"
            @click="loadApplication"
            :disabled-OFF="!application_id || application_id.length === 0"
          >Dispatch</el-button>
        </el-input>
      </div>

      <code
        v-if="['select', 'delete'].includes(method)"
        :class="['mt-3 text-truncate d-block', { 'text-success': load.select }]"
      >$store2.{{method}}('Application', { id: {{ requestId }} })</code>
      <code
        v-else-if="['create'].includes(method)"
        :class="['mt-3 text-truncate d-block', { 'text-success': load.select }]"
      >$store2.{{method}}('Application', data)</code>
      <code
        v-else-if="['update'].includes(method)"
        :class="['mt-3 text-truncate d-block', { 'text-success': load.select }]"
      >$store2.{{method}}('Application', data)</code>
    </section>

    <!-- <section class="mb-3 border rounded p-3 bg-light">
      <h4>
        Test: under the hood Vuex
        <code class="float-right">this.$store.getters['store2/models']</code>
      </h4>
      <code class="mt-3 text-truncate d-block">{{ $store.getters['store2/models'] }}</code>
    </section>-->

    <section class="mb-3 border rounded p-3 bg-light">
      <h4>Test: reactive properties</h4>
      <hr />
      <code
        class="mt-3 text-truncate d-block bg-secondary text-light border rounded p-2"
      >{{ $store2.model['Application'] }}</code>
      <code class="mt-3 text-truncate d-block">
        <span v-pre>{{ $store2.model["Application"] }}</span>
      </code>
    </section>

    <section class="mb-3 border rounded p-3 bg-light">
      <h4>Test: v-model 2-way binding</h4>
      <hr />
      <div class="mt-3 text-truncate">
        <el-input
          placeholder="Please input"
          v-model="$store2.model['Application'].customer_id"
          class="w-25"
        ></el-input>
      </div>
      <code
        class="mt-3 text-truncate d-block"
      >&lt;el-input v-model="$store2.model['Application'].customer_id"&gt;&lt;/el-input&gt;</code>
    </section>

    <section class="mb-3 border rounded p-3 bg-light">
      <h4>Test: deeply nested reactive properties</h4>
      <hr />
      <div v-if="$store2.model['Application'].aai">
        <code
          class="mt-3 text-truncate d-block bg-secondary text-light border rounded p-2"
        >{{ $store2.model['Application'].aai[0] }}</code>
        <code class="mt-3 text-truncate d-block">
          <span v-pre>{{ $store2.model['Application'].aai[0] }}</span>
        </code>
        <hr />
        <code
          class="mt-3 text-truncate d-block bg-secondary text-light border rounded p-2"
        >{{ $store2.model['Application'].aai[0].applicant_id }}</code>
        <code class="mt-3 text-truncate d-block">
          <span v-pre>{{ $store2.model['Application'].aai[0].applicant_id }}</span>
        </code>
        <hr />
        <el-input
          placeholder="Please input"
          v-model="$store2.model['Application'].aai[0].applicant_id"
          class="w-25"
        ></el-input>
        <code
          class="mt-3 text-truncate d-block"
        >&lt;el-input v-model="$store2.model['Application'].aai[0].applicant_id"&gt;&lt;/el-input&gt;</code>
      </div>
      <div v-else>Query returned a collection, not a single model.</div>
    </section>

    <section class="mb-3 border rounded p-3 bg-light">
      <h4>
        Test: computed properties (GET / SET) + v-model 2-way binding
        <!-- <code class="float-right">this.application</code> -->
      </h4>
      <hr />
      <label>Configuration</label>
      <code class="mt-2 text-truncate d-block">
        computed: {
        ...$store2.mapModels({ application: 'Application' })
        }
      </code>
      <hr />
      <code
        class="mt-3 text-truncate d-block bg-secondary text-light border rounded p-2"
      >{{ application }}</code>
      <code class="mt-3 text-truncate d-block">
        <span v-pre>{{ application }}</span>
      </code>
      <hr />
      <el-input placeholder="Please input" v-model="application.customer_id" class="w-25 mt-0"></el-input>
      <code
        class="mt-3 text-truncate d-block"
      >&lt;el-input v-model="application.customer_id"&gt;&lt;/el-input&gt;</code>
    </section>
  </section>
</template>

<script>
// import { mapGetters } from 'vuex'
import Vuex from 'vuex'
import JsonViewer from 'vue-json-viewer'

import MyComponent from './MyComponent'
import FullName from './FullName'

export default {
  components: {
    MyComponent,
    FullName,
    JsonViewer
  },
  props: {
  },
  data() {
    return {
      demoJson: '',
      // current_applicant: 0
      // application: null

      // Testing, not related to models or $store2
      application_id: null,
      current_applicant: 0,
      load: {
        select: false
      },
      method: 'select'
    }
  },
  computed: {
    // application: () => ({ customer_id: '000' }),

    methodName() {
      return this.method.charAt(0).toUpperCase() + this.method.slice(1)
    },

    requestId() {
      const id = this.application_id
      return id !== null && id.includes(',') ? `[${id}]` : (id || "''")
    },

    ...$store2.mapModels({
      application: 'Application',
      // aai_verbose: `Application.aai[${this.current_applicant}]`,
      // first_name: `Application.aai[${this.current_applicant}].first_name`
    })
  },
  watch: {
    // This...
    // ...$store.watch('application.aai', (newVal, oldVal) => { }),
    // Shorthand
    // ...$sw('application.aai', (newVal, oldVal) => { }),
    // Not this...
    // 'application.aai': (newVal, oldVal) => { },
  },
  mounted() {
    // this.loadDemoJson()

    // console.warn('aai', $store.value.application.aai)
    // Shorthand
    // console.warn('aai', $sv.application.aai)
    // $ aai { applicants: [...{}] }
    // console.warn('aai', $sv.application.aai[0].first_name)
    // $ aai John

    // ???
    // console.warn('aai', $s.application.$v.aai.applicants[0].first_name)

    /////////////////////////////////////////////////
    // Quick Summary
    /////////////////////////////////////////////////

    /////////////
    // OLD
    /////////////

    // $store.load('Application', {})
    // $store.watch('application.aai', (newVal, oldVal) => { })
    // $store.mapModel({ aai: 'application.aai' })
    // $store.mapState({ applicant_index: 'Application/getApplicantIndex' })
    // $store.model['Application'] //
    // $store.value['Application'] // whole application object (read-only)
    // $store.value['Application'].aai[0].applicant_id // nested parameter in Application object (read-only)
    // $store.calls['Application'].setApplicantIndex(1) // calls

    /////////////
    // NEW
    /////////////

    // API Calls
    // $store2.create('Application', {})

    // <===> Load Model into Memory <===>
    // $store2.select('Application', { id: 123 })

    // <===> Update Loaded Model <===>
    // Pass: "Application 123 was updated"
    // Fail: "Application model not loaded into memory"
    // $store2.update('Application', {})

    // $store2.delete('Application', {})

    // Special Methods
    // $store2.unload('Application') // unload selected model from memory

    // Reactive Vue Component Methods
    // $store2.mapModels({
    //   app: 'Application',
    //   aai_verbose: `Application.aai[${this.current_applicant}]`,
    //   first_name: `Application.aai[${this.current_applicant}].first_name`
    // })
    // $store2.mapModels({ aai: `Application.aai[{i}]` }, { i: this.current_applicant })

    // $store2.model('Application').id // = "null"
    // $store2.select('Application', { id: 123 }) // = { id: 123, customer_id: 001, ... }
    // $store2.model('Application').id // = "123"
  },
  updated() {
  },
  activated() {
  },
  methods: {
    loadApplication() {
      this.load.select = true
      let id = this.application_id || ''
      if (id.includes(',')) id = id.split(',')
      $store2.select('Application', { id })
      // $store2.select('Application', { id: this.application_id || '' })
      setTimeout(() => this.load.select = false, 1000)
    },

    encodeHtml(str) {
      return 'Hello'
      // return str.replace(/[\u00A0-\u9999<>\&]/gim, function (i) {
      //   return '&#' + i.charCodeAt(0) + ';';
      // })
    },

    loadDemoJson() {
      fetch('https://jsonplaceholder.typicode.com/posts')
        .then(response => response.json())
        .then(json => this.demoJson = json)
    }
  }
}
</script>

<style lang="scss" scoped>
// @import '@assets/sass/backend/_core-variables.scss';
pre {
  margin-bottom: 0;
}
* {
  transition: all 0.15s ease-in-out;
}
</style>
